import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "input_container" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center","justify-content":"right"} }
const _hoisted_3 = ["src"]

import { ref, watch } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'captchaField',
  props: {
  labelText: {
    type: String,
    default: () => ''
  },
  isShowError: {
    type: Boolean,
    default: () => false
  },
  captchaImg: {
    type: String,
  }
},
  emits: ['valueChanged', 'updateCaptcha'],
  setup(__props, { emit: __emit }) {

const props = __props

const isShow = ref(false)
const inputValue = ref('')

const emit = __emit


watch(() => inputValue.value, (newValue: string) => {
  emit('valueChanged', newValue)
});

const updateCaptcha = () => {
  console.log("click")
  emit('updateCaptcha')
}


return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_field, {
      modelValue: inputValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
      type: "text",
      placeholder: props.labelText
    }, {
      "right-icon": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: __props.captchaImg,
            alt: "",
            width: "100%",
            class: "iconImage",
            onClick: updateCaptcha
          }, null, 8, _hoisted_3)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "placeholder"])
  ]))
}
}

})